export * from "./show.component";
export * from "./list.component";
